import { render, staticRenderFns } from "./areaChart2.vue?vue&type=template&id=2a5f54bb&scoped=true&"
import script from "./areaChart2.vue?vue&type=script&lang=js&"
export * from "./areaChart2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5f54bb",
  null
  
)

export default component.exports